__turbopack_context__.v({
  "catalog": "Stars-module-scss-module__7LT6aa__catalog",
  "large": "Stars-module-scss-module__7LT6aa__large",
  "medium": "Stars-module-scss-module__7LT6aa__medium",
  "mobileCompact": "Stars-module-scss-module__7LT6aa__mobileCompact",
  "ratingBarStar": "Stars-module-scss-module__7LT6aa__ratingBarStar",
  "small": "Stars-module-scss-module__7LT6aa__small",
  "star": "Stars-module-scss-module__7LT6aa__star",
  "starActive": "Stars-module-scss-module__7LT6aa__starActive",
  "starButton": "Stars-module-scss-module__7LT6aa__starButton",
  "starFill": "Stars-module-scss-module__7LT6aa__starFill",
  "starInactive": "Stars-module-scss-module__7LT6aa__starInactive",
  "stars": "Stars-module-scss-module__7LT6aa__stars",
});
